import { useSelector } from 'react-redux'
import { Helpers } from '@briq/shared'

import { UserSelectors } from '../redux/user'

import { useSessionStorage } from './useSessionStorage'

export const useAuthorizations = () => {
  const userRoles = useSelector(UserSelectors.getUserRoles)

  const [loginAsValue] = useSessionStorage('isLoginAs', '')
  const isLoginAs = loginAsValue === 'true'
  const loginAsRoles = useSelector(UserSelectors.getLoginAsRoles)

  return {
    isAuthorizedForOrdering: Helpers.isAuthorizedForOrdering(isLoginAs, userRoles, loginAsRoles)
  }
}
